import styled from "styled-components";
import React, { useState } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { COLORS } from "../contants/colors";
import MorePopover from "./MorePopover";
import { QUERIES } from "../contants/allConstants";
import { format } from "date-fns";
import moment from "moment";
import { useSelector } from "react-redux";
import Fade from "react-reveal/Reveal";
import TransitionGroup from "react-transition-group/TransitionGroup";
import { useLanguageContext } from "../languageContext";
import { Divider } from "@mui/material";

const BigQuestion = ({ question, onDelete, onClick }) => {
  const { userInfo } = useSelector((state) => state.userLogin);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useLanguageContext();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const all_users_nbr = question.answers.reduce(
    (sum, a) => sum + a.users.length,
    0
  );
  const getAnswerPersentage = (answer) => {
    const users = answer.users.length;
    const percentage =
      users > 0 ? Math.round((users * 100) / all_users_nbr) : 0;
    return percentage;
  };
  const size = 150;
  const colors = [COLORS.primary, COLORS.orange, COLORS.yellow, COLORS.green01];

  return (
    <Fade bottom>
      {/* <Fade exit bottom duration={100}> */}
      <Question>
        <Body>
          <Wrapper>
            <Pie>
              {question.answers.length < 3 ? (
                <CircularProgressbar
                  value={getAnswerPersentage(question.answers[0])}
                  text={`%${getAnswerPersentage(question.answers[0])}`}
                  strokeWidth={20}
                  styles={{
                    path: {
                      stroke: COLORS.success,
                      fill: COLORS.success,
                    },
                    trail: {
                      stroke: COLORS.green30,
                    },
                    text: {
                      fill: "black",
                      fontSize: "15px",
                      fontFamily: "Montserrat",
                      fontWeight: 700,
                    },
                    background: {
                      fill: COLORS.success,
                    },
                  }}
                />
              ) : (
                <div
                  style={{ position: "relative", width: size, height: size }}
                >
                  {question.answers.map((a, i) => (
                    <div
                      style={{
                        position: "absolute",
                        top: 10 * i,
                        left: 10 * i,
                        width: size - 20 * i,
                        height: size - 20 * i,
                      }}
                    >
                      <CircularProgressbar
                        value={getAnswerPersentage(a)}
                        strokeWidth={20}
                        styles={buildStyles({
                          pathColor: colors[i % 4],
                          trailColor: COLORS.green30,
                        })}
                      />
                    </div>
                  ))}
                </div>
              )}
            </Pie>
            <Grid>
              {question.answers.map((a, index) => (
                <Answer>
                  <Dot color={colors[index % 4]} />
                  <span style={{ fontFamily: "Din" , marginRight:"10px"}}>{a.description}</span>
                </Answer>
              ))}
              {/* <div style={{ width: "8px" }} />
              <Answer>
                <LightDot />
                <span>{question["answers"][1]["description"]}</span>
              </Answer> */}
            </Grid>
          </Wrapper>
          <div
            style={{
              backgroundColor: COLORS.gray700,
              width: "0.7px",
              margin: "0 20px",
            }}
          />
          <Labels>
            <Title>{question["title"] ? question["title"] : "السؤال 1"}</Title>
            {question["subject"] && <Subtitle>{question["subject"]}</Subtitle>}
            <Description>{question["description"]}</Description>
            {question.answers.map((a) => (
              <Result>
                {a.users.length + t("answer") + " : " + a.description}
              </Result>
            ))}

            <Footer>
              {question["company"] && (
                <div>
                  <Strong>{t("company")}</Strong>
                  <p>{question["company"]}</p>
                </div>
              )}
              <div style={{ padding: "0 5px" }}>
                <Strong>{t("dateShare")}</Strong>
                <p>
                  {format(
                    new Date(question["createdAt"]),
                    "dd/MM/yyyy - HH:mm"
                  )}
                </p>
              </div>
              <div>
                <Strong>{t("ending")}</Strong>
                <p>
                  {new Date(question["expireAt"]) < new Date()
                    ? t("ended")
                    : ""}
                  {moment
                    .utc(question["expireAt"])
                    .local()
                    .endOf("seconds")
                    .fromNow()}
                </p>
              </div>
            </Footer>
          </Labels>
          <MorePopover
            onDelete={() => onDelete(question["_id"])}
            canDelete={userInfo.isAdmin}
            showDetails={true}
            onOpenDetails={() => onClick(question)}
            handleClick={handleClick}
            open={open}
            setOpen={setOpen}
            anchorEl={anchorEl}
            top={0}
          />
        </Body>
      </Question>
      {/* </Fade> */}
    </Fade>
  );
};
const Question = styled.div`
  background-color: white;
  border-radius: 15px;
  margin-top: 20px;
`;
const Body = styled.div`
  display: flex;
  position: relative;
  padding: 32px 20px;

  @media (${QUERIES.mobileAndDown}) {
    flex-direction: column;
  }
`;
const Footer = styled.div`
  padding-top: 20px;
  color: ${COLORS.gray30};
  font-family: "Din";
  font-size: 0.75rem;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  width: 90%;
`;
const Strong = styled.span`
  color: ${COLORS.gray550};
  font-size: 0.75rem;
  font-weight: 400;
  margin-right: 5px;
`;

const Wrapper = styled.div`
  width: 30vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (${QUERIES.mobileAndDown}) {
    width: 100%;
    border: none;
    padding: 0;
  }
`;
const Pie = styled.div`
  width: 136px;
  margin-bottom: 27px;
`;
const Answer = styled.div`
  display: flex;
  align-items: center;
  max-width: max-content;
  overflow-wrap: anywhere;
`;
const Row = styled.div`
  width: 100%;
  display: flex;
  font-family: "Din";
  font-size: 1rem;
  font-weight: 500;
  color: black;
  align-items: center;
  justify-content: space-between;
`;
const Dot = styled.span`
  height: 25px;
  min-width: 25px;
  background-color: ${(p) => p.color};
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
`;
const LightDot = styled(Dot)`
  background-color: ${COLORS.green30};
`;

const Labels = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: black;
  font-family: "Din";
  font-size: 1rem;
  align-items: flex-start;
  justify-content: center;
  padding-left: 20px;
  width: 100%;
  @media (${QUERIES.mobileAndDown}) {
    padding-left: 0;
    margin-top: 20px;
  }
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 1.1rem;
`;
const Subtitle = styled.div`
  font-weight: 600;
  padding-top: 10px;
`;

const Description = styled.div`
  font-weight: 400;
  font-size: 0.9rem;
  /* padding-top: 13px; */
`;
const Result = styled.div`
  font-weight: 500;
  padding-top: 13px;
`;
const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  grid-row-gap: 15px;
  grid-column-gap: 5px;
  margin-top: 20px;
`;
export default BigQuestion;
